<div
  [style.padding-bottom]="layoutSvc.offsetBottom"
  class="med-layout"
>
  <med-warship-banner
    *ngIf="layoutSvc.config.visibleBanner"
    [style.width]="layoutSvc.headerWidth"
    [linkBanner]="layoutSvc.config.bannerLink"
    class="med-layout__banner"
    (close)="layoutSvc.config.visibleBanner = !layoutSvc.config.visibleBanner"
  >
    <ng-content select="[banner]"></ng-content>
  </med-warship-banner>

  <med-header
    [logoUrl]="layoutSvc.config.logoLink"
    [headerAppLogo]="layoutSvc.config.logoSrc"
    [ngClass]="layoutSvc.config.headerClassList"
    [justifyContent]="layoutSvc.config.headerJustifyContent"
    [style.width]="layoutSvc.headerWidth"
    [style.height]="layoutSvc.config.headerHeight"
    class="med-layout__header"
  >
    <ng-content select="[header]"></ng-content>
  </med-header>

  <div
    [style.min-width]="layoutSvc.contentWidth"
    class="med-layout__main"
  >
    <div
      [hidden]="!layoutSvc.config.visibleAsideLeft"
      [style.top]="layoutSvc.offsetTop"
      [style.height]="layoutSvc.asideHeight"
      [style.width]="layoutSvc.config.asideLeftWidth"
      [style.padding-bottom]="layoutSvc.offsetBottom"
      [style.flex]="layoutSvc.asideLeftFlexWidth"
      class="med-layout__left"
    >
      <ng-content select="[left-aside]"></ng-content>
    </div>

    <div [style.flex]="layoutSvc.contentFlexWidth">
      <ng-content></ng-content>
    </div>

    <div
      [hidden]="!layoutSvc.config.visibleAsideRight"
      [style.width]="layoutSvc.config.asideRightWidth"
      [style.top]="layoutSvc.offsetTop"
      [style.flex]="layoutSvc.asideRightFlexWidth"
      [style.padding-bottom]="layoutSvc.offsetBottom"
      [style.height]="layoutSvc.asideHeight"
      class="med-layout__right"
    >
      <ng-content select="[right-aside]"></ng-content>
    </div>
  </div>
</div>

<div
  [hidden]="!layoutSvc.config.visibleFooter"
  [style.width]="layoutSvc.headerWidth"
  [style.height]="layoutSvc.config.footerHeight"
  class="med-layout__footer"
>
  <div class="med-layout__footer-content">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
